import { createRouter, createWebHistory } from 'vue-router';
import routeName from './route-name.ts';

export default createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/auth',
            component: () => import('../layouts/DefaultLayout.vue'),
            children: [
                {
                    path: 'login',
                    name: routeName.login,
                    component: () => import('../pages/auth/login.vue'),
                },
            ],
        },
        {
            path: '/invoices',
            component: () => import('../layouts/ListLayout.vue'),
            children: [
                {
                    path: '',
                    name: routeName.invoices,
                    component: () => import('../pages/invoices/InvoicesView.vue'),
                },
                {
                    path: 'add',
                    name: routeName.invoiceAdd,
                    component: () => import('../pages/invoices/AddInvoiceView.vue'),
                },
                {
                    path: 'edit/:id',
                    name: routeName.invoiceEdit,
                    component: () => import('../pages/invoices/AddInvoiceView.vue'),
                },
                {
                    path: 'correction/:id',
                    name: routeName.invoiceCorrection,
                    component: () => import('../pages/invoices/AddInvoiceView.vue'),
                },
            ],
        },
        {
            path: '/files',
            component: () => import('../layouts/ListLayout.vue'),
            children: [
                {
                    path: '',
                    name: routeName.files,
                    component: () => import('../pages/files/FilesView.vue'),
                },
                {
                    path: 'upload',
                    name: routeName.filesUpload,
                    component: () => import('../pages/files/FilesUploadView.vue'),
                },
                {
                    path: ':id(\\d+)',
                    name: routeName.fileEdit,
                    component: () => import('../pages/files/FileEditView.vue'),
                },
            ],
        },
        {
            path: '/',
            component: () => import('../layouts/AppLayout.vue'),
            children: [
                {
                    path: '/dashboard',
                    name: routeName.dashboard,
                    component: () => import('../pages/dashboard.vue'),
                },
            ],
        },
        {
            path: '/ksef',
            component: () => import('../layouts/ListLayout.vue'),
            children: [
                {
                    path: '',
                    name: routeName.ksef,
                    component: () => import('../pages/ksef/KsefView.vue'),
                },
                {
                    path: 'invoice/:id',
                    name: routeName.ksefInvoiceDetail,
                    component: () => import('../pages/ksef/KsefInvoiceDetailView.vue'),
                },
            ],
        },
        {
            path: '/settings',
            component: () => import('../layouts/ListLayout.vue'),
            children: [
                {
                    path: '',
                    name: routeName.settings,
                    component: () => import('../pages/settings/SettingsView.vue'),
                },
                {
                    path: 'ksef',
                    name: routeName.settingsKsef,
                    component: () => import('../pages/settings/ksef/KsefSettingsView.vue'),
                },
                {
                    path: 'mailing',
                    name: routeName.settingsMailing,
                    component: () => import('../pages/settings/mailing/MailingSettingsView.vue'),
                },
                {
                    path: 'two-factor',
                    name: routeName.settingsTwoFactor,
                    component: () => import('../pages/settings/two-factor/TwoFactorSettingsView.vue'),
                },
            ],
        },
        {
            path: '/crm',
            component: () => import('../layouts/ListLayout.vue'),
            children: [
                {
                    path: '',
                    name: routeName.crm,
                    component: () => import('../pages/crm/CrmView.vue'),
                },
                {
                    path: 'new-simplified',
                    name: routeName.crmNewSimplified,
                    component: () => import('../pages/crm/CrmSimplifiedFormView.vue'),
                },
                {
                    path: ':id(\\d+)/edit-simplified',
                    name: routeName.crmEditSimplified,
                    component: () => import('../pages/crm/CrmSimplifiedFormView.vue'),
                },
                {
                    path: 'new-full',
                    name: routeName.crmNewFull,
                    component: () => import('../pages/crm/CrmFullFormView.vue'),
                },
                {
                    path: ':id(\\d+)/edit',
                    name: routeName.crmEditFull,
                    component: () => import('../pages/crm/CrmFullFormView.vue'),
                },
            ],
        },
        {
            path: '/:pathMatch(.*)*',
            name: routeName.notFound,
            component: undefined!,
            beforeEnter: (to, from, next) => next({ name: routeName.dashboard }),
        },
    ],
});
